import { z } from 'zod';

export const SUMMARY_PAYMENT_CONTENT_PATH = 'licenses.steps.summaryPayment';

// Schema for payment information step.
export const PaymentInformationSchema = z.object({
  acceptTerms: z.boolean().refine(val => val === true, {
    message: `${SUMMARY_PAYMENT_CONTENT_PATH}.termsAndNewsletter.terms.validation.required`,
  }),
  subscribeNewsletter: z.boolean().optional(),
  sticker: z.boolean().optional(),
  eanNumber: z.string().optional(),
});

export type PaymentInformation = z.infer<typeof PaymentInformationSchema>;

export const defaultPaymentInformation: PaymentInformation = {
  acceptTerms: false,
  subscribeNewsletter: false,
  sticker: false,
  eanNumber: undefined,
};
